import Kfit from 'integrations/Kfit';

export default address => Kfit.get(`/v6/get_geo_location?address=${address}`);
